import React from 'react';
import { themeFor, themeVars } from '../config/theme';
import '../styles/ElementIcon.scss';

// Two-tone glyphs on a 32×32 grid. Classes: d = detail, m = main, l = highlight, s = stroke.
const GLYPHS = {
  overview: (<>
    <rect className="m" x="4" y="20" width="5" height="8" rx="2" />
    <rect className="m" x="10.5" y="15" width="5" height="13" rx="2" />
    <rect className="d" x="17" y="10" width="5" height="18" rx="2" />
    <rect className="m" x="23.5" y="5" width="5" height="23" rx="2" />
    <circle className="l" cx="19.5" cy="14" r="1.6" />
  </>),
  ownership: (<>
    <circle className="m" cx="16" cy="16" r="11" />
    <path className="d" d="M16 16V5a11 11 0 0 1 10.4 14.6z" />
    <circle className="l" cx="16" cy="16" r="2.2" />
  </>),
  management: (<>
    <circle className="m" cx="10" cy="8" r="2.8" /><circle className="m" cx="16" cy="7" r="2.8" /><circle className="m" cx="22" cy="8" r="2.8" />
    <circle className="m" cx="10" cy="24" r="2.8" /><circle className="m" cx="16" cy="25" r="2.8" /><circle className="m" cx="22" cy="24" r="2.8" />
    <rect className="d" x="5" y="12.5" width="22" height="7" rx="3.5" />
  </>),
  skills: (<>
    <path className="m" d="M9 15.5v5.2c0 2.3 3.2 4.3 7 4.3s7-2 7-4.3v-5.2l-7 3.4z" />
    <path className="d" d="M3.5 12.5 16 6.5l12.5 6L16 18.5z" />
    <path className="s" d="M26 13.5v6.5" />
    <circle className="d" cx="26" cy="21.5" r="1.8" />
  </>),
  procurement: (<>
    <path className="m" d="M8 4.5h16v23l-2.7-1.8-2.6 1.8-2.7-1.8-2.7 1.8-2.6-1.8L8 27.5z" />
    <rect className="d" x="11.5" y="9" width="9" height="2.4" rx="1.2" />
    <rect className="l" x="11.5" y="14" width="9" height="2" rx="1" />
    <rect className="l" x="11.5" y="18" width="6" height="2" rx="1" />
  </>),
  esd: (<>
    <circle className="m" cx="12" cy="16" r="8" />
    <circle className="d" cx="20" cy="16" r="8" style={{ opacity: 0.85 }} />
    <path className="l" d="M16 10.2a8 8 0 0 1 0 11.6 8 8 0 0 1 0-11.6z" />
  </>),
  sed: (<>
    <path className="m" d="M5 14.5 16 5l11 9.5V26a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z" />
    <path className="d" d="M16 24.5s-5.5-3.3-5.5-7a3 3 0 0 1 5.5-1.7 3 3 0 0 1 5.5 1.7c0 3.7-5.5 7-5.5 7z" />
  </>),
  finance: (<>
    <ellipse className="m" cx="16" cy="23" rx="9" ry="3.5" />
    <rect className="m" x="7" y="16" width="18" height="7" />
    <ellipse className="d" cx="16" cy="16" rx="9" ry="3.5" />
    <rect className="d" x="7" y="9" width="18" height="7" />
    <ellipse className="m" cx="16" cy="9" rx="9" ry="3.5" />
  </>),
  reports: (<>
    <rect className="m" x="5" y="4" width="22" height="24" rx="3.5" />
    <rect className="d" x="9" y="17" width="3.5" height="7" rx="1.5" />
    <rect className="d" x="14.3" y="12" width="3.5" height="12" rx="1.5" />
    <rect className="d" x="19.6" y="8" width="3.5" height="16" rx="1.5" />
  </>),
  scenario: (<>
    <path className="s" d="M16 6v20M8 26h16" />
    <path className="s" d="M5 10h22" style={{ strokeWidth: 2.4 }} />
    <path className="m" d="M4 17l4-7 4 7a4 4 0 0 1-8 0z" />
    <path className="m" d="M20 17l4-7 4 7a4 4 0 0 1-8 0z" />
    <circle className="d" cx="16" cy="6" r="2.4" />
  </>),
};

// element: any backend element/group key or theme key. size: 'sm' | 'md' | 'lg'.
const ElementIcon = ({ element, size = 'md', className = '' }) => (
  <span className={`el-icon el-icon--${size} themed ${className}`} style={themeVars(element)} aria-hidden="true">
    <svg viewBox="0 0 32 32">{GLYPHS[themeFor(element).glyph]}</svg>
  </span>
);

export default ElementIcon;
